export default __webpack_public_path__ + "static/media/element_25.eaac0de8.avif";